<template>
  <div class="ims-countdown" v-if="this.expires">
    <div v-if="expired">
      <slot name="finished"></slot>
    </div>
    <div v-else><slot name="during"></slot> {{ remaining }}</div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
let countdownInterval;
export default {
  data() {
    return {
      remaining: null,
      expired: false,
      date: null
    };
  },
  props: {
    title: {
      type: String,
      default() {
        return 'Ends ';
      }
    },
    expires: {
      default() {
        return null;
      }
    }
  },
  methods: {
    start() {
      if (countdownInterval) {
        clearInterval(countdownInterval);
      }
      // Start the Teimer with setInterval
      countdownInterval = setInterval(() => {
        // If the date has passed
        if (this.date <= new Date()) {
          // Set it to finished
          this.remaining = 'Finished';
          this.expired = true;
          // Clear Interface
          clearInterval(countdownInterval);
          // Fire end event
          this.$emit('end');
        } else {
          // Not expired
          this.expired = false;
          // Set remaining
          this.remaining = dayjs(this.date).fromNow(true);
        }
      }, 1000);
      // Fire off remiaining immediately
      this.remaining = dayjs(this.date).fromNow(true);
    },
    end() {
      clearInterval(countdownInterval);
    }
  },
  updated() {
    if (this.expires) {
      this.date = new Date(this.expires);
      this.start();
    }
  },
  mounted() {
    if (this.expires) {
      this.date = new Date(this.expires);
      this.start();
    }
  },
  destroyed() {
    this.end();
  }
};
</script>

<style lang="scss">
.ims-countdown {
  padding: 2px 8px;
  font-size: 0.7rem;
  text-align: center;
}
</style>
